// export const environment = {
//   production: false,
//   cognito: {
//     userPoolId: 'ap-southeast-1_8M7qtSkYO',
//     userPoolWebClientId: '3nnb536m5as0nbhf90ugnstk03',
//   },
//   s3accessKeyId: 'AKIA3VW6M4S4IQHCEJOP',
//   s3secretAccessKey: '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',
//   s3region: 'ap-southeast-1',
//   s3BucketName: 'v3-agrikb-dev-v3-ap-southeast-1-bucket',
//   s3BucketUrlName: 'agritool-websrc-dev',
//   domainName: "https://agrikbdevv6.agrikb.com",
//   s3Url: "https://v3agrikbdev.agrikb.com/",
//   registrationReadGateway: "https://tevl4ki7wb.execute-api.ap-southeast-1.amazonaws.com/agrikb-dev-v7/readRegGateway",
//   registrationWriteGateway: "https://xt4k56sm49.execute-api.ap-southeast-1.amazonaws.com/agrikb-dev-v7/writeRegGateway",
//   ecommerceReadGateway: "https://31zmgsi3o1.execute-api.ap-southeast-1.amazonaws.com/agrikb-dev-v7/readCommerceGateway",
//   ecommerceWriteGateway: "https://4d10kln3q3.execute-api.ap-southeast-1.amazonaws.com/agrikb-dev-v7/writeCommerceGateway",
//   healthReadGateway: "https://xaut5jcdvf.execute-api.ap-southeast-1.amazonaws.com/agrikb-dev-v7/readHealthGateway",
//   healthWriteGateway: "https://44c94j1a9d.execute-api.ap-southeast-1.amazonaws.com/agrikb-dev-v7/writeHealthGateway"
// };


// prod

export const environment = {
  production: true,
  cognito: {
    userPoolId: "ap-south-1_w6GrXWXuv",
    userPoolWebClientId: "4jvp2jhhludl3c8v2unc8sve14",
  },
  s3accessKeyId: 'AKIA3VW6M4S4IQHCEJOP',
  s3secretAccessKey: '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',
  s3region: "ap-south-1",
  // // s3region: 'ap-southeast-1',
  s3BucketName: "v3-agrikb-prod-v3-ap-south-1-bucket",
  webHostings3BucketName: "prod-v6-agrikb-static-website",
  website: "https://agrikb.com",
  s3Url: "https://agrikbv3prod.agrikb.com/",
  registrationReadGateway: "https://egjngxiqe0.execute-api.ap-south-1.amazonaws.com/agrikb-prod-v7/readRegGateway",
  registrationWriteGateway: "https://vm0jj92ew4.execute-api.ap-south-1.amazonaws.com/agrikb-prod-v7/writeRegGateway",
  ecommerceReadGateway: "https://qk5h3uq8pg.execute-api.ap-south-1.amazonaws.com/agrikb-prod-v7/readCommerceGateway",
  ecommerceWriteGateway: "https://bw6vrxyfs4.execute-api.ap-south-1.amazonaws.com/agrikb-prod-v7/writeCommerceGateway",
  healthReadGateway: "https://a5wcosmfwh.execute-api.ap-south-1.amazonaws.com/agrikb-prod-v7/readHealthGateway",
  healthWriteGateway: "https://mdv33dwp16.execute-api.ap-south-1.amazonaws.com/agrikb-prod-v7/writeHealthGateway",
};


//Old dev access key ids:-
//   s3accessKeyId: 'AKIA3VW6M4S4D4KNDRXE',
//   s3secretAccessKey: '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',

//Old prod access key ids:-
//   s3accessKeyId: 'AKIA3VW6M4S4D4KNDRXE',
//   s3secretAccessKey: '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',
